module.exports = "/public/images/faena.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/faena.png
// module id = 3884
// module chunks = 0